import CartStorage from "../../utils/cartStorage";
import BaseCheckoutItemsValidator from "../../utils/baseCartItemsValidator";
import { getCartItemsFromStorage } from '../swiss_ui/cart/Cart';

/**
 * A helper class providing an interface for validating checkout items on the server-side and handling validation response.
 * Allows flexible integration with different render classes, which may be Checkout Sidebar Renderer or Cart Renderer.
 * @extends BaseCheckoutItemsValidator
 */
export class CheckoutItemsValidator extends BaseCheckoutItemsValidator
{
  /**
   * @inheritDoc
   */
  constructor() {
    super();
    this.setCart(new CartStorage());
    return this;
  }

  /**
   * Initialize validator
   *
   * @returns {CheckoutItemsValidator}
   */
  init() {
    this.cacheCartData();
    return this;
  }

  /**
   * Customize before request
   */
  beforeRequest() {
    if(this.hasRenderer()) {
      this.renderer.sidebarLoading();
    }
  }


  /**
   * Handle cart validation response
   *
   * Render errors if there are any
   *
   * @param response
   */
  handleValidationResponse(response) {
    if(this.hasRenderer()) {
      // console.log('first validation res');
      const cartItems = getCartItemsFromStorage();

      // const resultCartItems = [];
      //
      // console.log(response);
      //
      // //  TODO If Response Required in CartItems add That
      // cartItems.forEach(cartItem => {
      //
      //   let status = false;
      //
      //    switch (cartItem.getType()) {
      //
      //      case SERVICE_CATEGORIES.ACTIVITIES:
      //        const data = response.tours.items[cartItem.id];
      //        if(data){
      //          status = data.status;
      //          cartItem.updateData(data);
      //        }
      //        break;
      //      case SERVICE_CATEGORIES.HOTELS:
      //        const rooms = response.hotels.items.filter(hotel => hotel.hotel_id === cartItem.getId());
      //        const roomsInCarts = cartItem.getRooms();
      //
      //        const updatedRooms = roomsInCarts.reduce((updatedRooms, roomType) => {
      //          const roomDetails = rooms.find(room => room.room_type_id === roomType.id);
      //          if(roomDetails && roomDetails.status){
      //            updatedRooms.push(roomType);
      //          }
      //          return updatedRooms;
      //        }, []);
      //
      //        cartItem.updateData({
      //          ...cartItem,
      //          rooms: updatedRooms
      //        });
      //        break;
      //    }
      //
      //    if(status){
      //      resultCartItems.push(cartItem);
      //    }
      // });
      //
      // console.log(resultCartItems);

      this.renderer.begin(cartItems);
      this.hideCheckoutFullScreenLoader();
    }
  }

  hideCheckoutFullScreenLoader() {
    const checkoutFullScreenLoader = document.getElementById('checkoutFullScreenLoader');
    if(!checkoutFullScreenLoader.classList.contains('d-none')){
      checkoutFullScreenLoader.classList.toggle('d-none')
    }
  }

  /**
   * @param error
   */
  handleValidationError(error) {
    this.notifier.error(error.response.data.message);
    if(this.hasRenderer()
      && this.renderer.handleCartValidationError !== undefined
      && typeof this.renderer.handleCartValidationError === "function") {
      // this.renderer.begin(error);
      this.hideCheckoutFullScreenLoader();
      this.renderer.handleCartValidationError();
    }
  }
}

